import { lazy } from "react";
import type { IntakeProgressProps, IntakeSummaryRow } from "./IntakeProgress";
const IntakeProgress = lazy(() => import("./IntakeProgress").then(module => ({ default: module.IntakeProgress })));
const IntakeSummary = lazy(() => import("./IntakeProgress").then(module => ({ default: module.IntakeSummary })));
import { setStudioView } from "../workspace/studio-views";
export function mountIntakeProgress(
  slot: HTMLElement,
  props: IntakeProgressProps,
) {
  setStudioView("intake-progress", "intake-progress", <IntakeProgress {...props} />);
}
export function mountIntakeSummary(
  slot: HTMLElement,
  rows: IntakeSummaryRow[],
  disabled: boolean,
  jump: (index: number) => void,
) {
  setStudioView("intake-summary", "intake-summary", <IntakeSummary rows={rows} disabled={disabled} jump={jump} />);
}
